var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"light":"","flat":"","label":_vm.label,"rules":_vm.rules,"background-color":_vm.backgroundColor,"outlined":_vm.outlined,"disabled":_vm.disabled},on:{"focus":_vm.onFocus,"blur":_vm.onBlur},model:{value:(_vm.timeLocal),callback:function ($$v) {_vm.timeLocal=$$v},expression:"timeLocal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }